import { useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { MENU_OPTIONS, SUBSCRIBER_MENU_OPTIONS } from "../../data/Account";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

export default function AccountPopover({ role }) {
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const userDataString = secureLocalStorage.getItem("userInfo");
  const userData = JSON.parse(userDataString);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    secureLocalStorage.removeItem("Subscription");
    secureLocalStorage.removeItem("Id");
    secureLocalStorage.removeItem("Status");
    secureLocalStorage.removeItem("role");
    secureLocalStorage.removeItem("userInfo");
    secureLocalStorage.removeItem("SubInfo");
    navigate("/signin");
    setOpen(null);
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
  };

  const menuOptions = role === "admin" ? MENU_OPTIONS : SUBSCRIBER_MENU_OPTIONS;

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          backgroundColor: open ? "var(--color-white-50)" : "transparent",
          borderRadius: open ? "50%" : "0",
          transition: "background-color 0.3s ease, border-radius 0.3s ease",
          "&:hover": {
            backgroundColor: open
              ? "var(--color-darksalmon-200)"
              : "rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <Avatar
          src={userData.photo_url}
          alt={userData.name}
          sx={{
            width: 30,
            height: 30,
            border: `solid 2px var(--white)`,
            backgroundColor: "#d0c9c9a6",
          }}
        >
          {userData.photo_url ? null : userData.name.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      {userData != null || userData != undefined ? (
        <Popover
          open={!!open}
          anchorEl={open}
          onClose={() => setOpen(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            sx: {
              p: 0,
              mt: 1,
              ml: 0.75,
              width: 200,
              backgroundColor: "#222222", //#201939eb
            },
          }}
        >
          <Box sx={{ my: 1.5, px: 2 }}>
            <Typography variant="subtitle2" noWrap color={"var(--white)"}>
              {userData.name}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "var(--color-white-50)" }}
              noWrap
            >
              {userData.email}
            </Typography>
          </Box>

          <Divider
            sx={{
              borderStyle: "dashed",
              backgroundColor: "var(--white)",
            }}
          />

          {menuOptions.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => handleMenuItemClick(option.path)}
              sx={{
                color: "var(--white)",
                marginTop: "0.2vw",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              {option.label}
            </MenuItem>
          ))}
          <Divider
            sx={{ borderStyle: "dashed", m: 0, background: "var(--white)" }}
          />

          <MenuItem
            disableRipple
            disableTouchRipple
            onClick={handleClose}
            sx={{
              typography: "body2",
              color: "error.main",
              py: 1.5,
              "&:hover": {
                backgroundColor: "#291d1d",
              },
            }}
          >
            Logout
          </MenuItem>
        </Popover>
      ) : (
        console.log("Null or undefined")
      )}
    </>
  );
}
